import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { AnalisisDemandaService } from 'src/app/services/analisis-demanda.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { ModalSeleccionarProductoComponent } from 'src/app/views/shared/modal-seleccionar-producto/modal-seleccionar-producto.component';
import { debounceTime, filter } from 'rxjs/operators';
import * as _ from 'lodash';

@Component({
  selector: 'app-historico-quiebres',
  templateUrl: './historico-quiebres.component.html',
  styleUrls: ['./historico-quiebres.component.scss'],
  providers: [SecurityService],
})
export class HistoricoQuiebresComponent implements OnInit {
  // Modales
  @ViewChild(ModalSeleccionarProductoComponent, { static: true }) modalSeleccionarProducto: ModalSeleccionarProductoComponent;

  // Form
  formHeader: FormGroup;

  // Data
  private rutEmpresa: number;
  private sucursalCodigo: number;
  loading: boolean = false;
  exportandoExcel: boolean = false;
  datosReporte: Array<any> = null; // Mantenido para compatibilidad con exportarExcel
  datosReporteUnificado: Array<any> = [];
  datosReporteUnificadoAll: Array<any> = []; // Mantenido para compatibilidad
  productoSeleccionado: any = null;

  // Pagination
  paginationContext: PaginationContext = new PaginationContext();

  // Totales
  totalQuiebreCantidad: number = 0;
  totalQuiebreFraccion: number = 0;

  // Utils
  private log: any;

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService,
    private datesService: DatesService,
    private fileDownloadService: FileDownloadService,
    private rutService: RutService,
    private analisisDemandaService: AnalisisDemandaService
  ) {
    this.log = this.clog.log('HISTORICO-QUIEBRES');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10;

    this.createForm();
    this.formChangesSubscriptions();
  }

  private dateRangeValidator(): any {
    return (group: AbstractControl): { [key: string]: any } | null => {
      const fechaDesdeControl = group.get('fechaDesde');
      const fechaHastaControl = group.get('fechaHasta');

      const fechaDesdeValue = fechaDesdeControl && fechaDesdeControl.value;
      const fechaHastaValue = fechaHastaControl && fechaHastaControl.value;

      if (fechaDesdeValue && fechaHastaValue) {
        const fechaDesde = new Date(fechaDesdeValue);
        const fechaHasta = new Date(fechaHastaValue);

        const diffMonths =
          (fechaHasta.getFullYear() - fechaDesde.getFullYear()) * 12 +
          (fechaHasta.getMonth() - fechaDesde.getMonth());

        if (diffMonths > 12) {
          return { maxRangeDate: true };
        }
      }

      return null;
    };
  }

  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();
    this.formHeader = this.fb.group({
      fechaDesde: [initDate, [Validators.required]],
      fechaHasta: [currentDate, [Validators.required]],
      sku: [null],
    }, { validator: this.dateRangeValidator() });
  }

  formChangesSubscriptions() {
    this.formHeader.get('sku').valueChanges
      .pipe(filter(Boolean), debounceTime(500))
      .subscribe((codigo: string) => {
        this.modalSeleccionarProducto.searchBySKU(codigo);
      });

    this.formHeader.get('fechaDesde').valueChanges.subscribe(() => this.validarRangoFechas12Meses());
    this.formHeader.get('fechaHasta').valueChanges.subscribe(() => this.validarRangoFechas12Meses());
  }

  private validarRangoFechas12Meses(): void {
    const ctrlDesde = this.formHeader.get('fechaDesde');
    const ctrlHasta = this.formHeader.get('fechaHasta');
    const fechaDesde = ctrlDesde.value;
    const fechaHasta = ctrlHasta.value;
    if (!fechaDesde || !fechaHasta) {
      this.clearMaxRangeDateError(ctrlDesde);
      this.clearMaxRangeDateError(ctrlHasta);
      return;
    }
    const dDesde = new Date(fechaDesde);
    const dHasta = new Date(fechaHasta);
    const diffMonths =
      (dHasta.getFullYear() - dDesde.getFullYear()) * 12 +
      (dHasta.getMonth() - dDesde.getMonth());
    if (diffMonths > 12) {
      ctrlDesde.setErrors({ ...(ctrlDesde.errors || {}), maxRangeDate: true });
      ctrlHasta.setErrors({ ...(ctrlHasta.errors || {}), maxRangeDate: true });
    } else {
      this.clearMaxRangeDateError(ctrlDesde);
      this.clearMaxRangeDateError(ctrlHasta);
    }
  }

  private clearMaxRangeDateError(ctrl: AbstractControl): void {
    const err = ctrl.errors;
    if (!err || !err.maxRangeDate) return;
    const { maxRangeDate, ...rest } = err;
    ctrl.setErrors(Object.keys(rest).length ? rest : null);
  }

  openModalSeleccionarProducto() {
    this.modalSeleccionarProducto.show();
  }

  onProductoSeleccionado({ data: _productoSeleccionado }) {
    this.productoSeleccionado = _productoSeleccionado;
    this.formHeader.get('sku').setValue(_productoSeleccionado.sku);
  }

  onProductoNoEncontrado() {
    this.productoSeleccionado = null;
  }

  limpiarFiltros() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();
    this.formHeader.reset();
    this.productoSeleccionado = null;
    this.formHeader.get('fechaDesde').setValue(initDate);
    this.formHeader.get('fechaHasta').setValue(currentDate);
    this.formHeader.get('sku').setValue(null);
    this.datosReporte = null;
    this.datosReporteUnificado = [];
    this.datosReporteUnificadoAll = [];
    this.totalQuiebreCantidad = 0;
    this.totalQuiebreFraccion = 0;
    this.paginationContext.RecordsCount = 0;
  }

  buscarReporte() {
    this.validarRangoFechas12Meses();
    this.formValidatorsService.validateAllFormFields(this.formHeader);
    if (!this.formHeader.valid) return;

    this.paginationContext.CurrentPage = 1;

    const { fechaDesde, fechaHasta, sku } = this.formHeader.value;

    const inputParams = {
      rut_empresa: this.rutEmpresa,
      sucursal_codigo: this.sucursalCodigo,
      fecha_inicio_busqueda: fechaDesde,
      fecha_termino_busqueda: fechaHasta,
      sku: sku || null,
      producto_codigo: (this.productoSeleccionado && this.productoSeleccionado.codigo) ? this.productoSeleccionado.codigo : 0,
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage,
    };

    this.log('Buscando reporte con parámetros:', JSON.stringify(inputParams));

    this.loading = true;

    // Usar el nuevo método centralizado que devuelve datos ya agrupados y calculados
    this.analisisDemandaService.obtenerHistoricoQuiebresAgrupado(inputParams, ({ mensajes, respuesta }) => {
      // Mostrar mensajes informativos pero continuar procesando
      if (mensajes && mensajes.length > 0) {
        const errores = mensajes.filter(m => m.tipo === 'ERROR' || m.tipo === 'WARNING');

        if (errores && errores.length > 0) {
          this.messageRendererService.showErrors(errores);
          this.loading = false;
          return;
        }
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta || {
        registros: [],
        paginaActual: 1,
        totalPaginas: 0,
        totalRegistros: 0
      };

      if (registros && registros.length > 0) {
        // Los datos ya vienen agrupados y calculados del backend
        this.datosReporte = registros; // Establecer para que el HTML muestre la tabla
        this.datosReporteUnificado = registros;
        this.datosReporteUnificadoAll = registros; // Para mantener compatibilidad con paginación

        // Actualizar contexto de paginación
        this.paginationContext.CurrentPage = paginaActual;
        this.paginationContext.PagesCount = totalPaginas;
        this.paginationContext.RecordsCount = totalRegistros;

        // Calcular totales de quiebres
        this.totalQuiebreCantidad = registros.reduce((sum, item) => sum + Math.abs(item.quiebreCantidad || 0), 0);
        this.totalQuiebreFraccion = registros.reduce((sum, item) => sum + Math.abs(item.quiebreFraccion || 0), 0);
      } else {
        // Cuando no hay datos, inicializar arrays vacíos para mostrar el mensaje
        this.datosReporte = [];
        this.datosReporteUnificado = [];
        this.datosReporteUnificadoAll = [];
        this.totalQuiebreCantidad = 0;
        this.totalQuiebreFraccion = 0;
        this.paginationContext.RecordsCount = 0;
        this.paginationContext.PagesCount = 0;
      }
      this.loading = false;
    });
  }

  // Métodos de procesamiento eliminados - ahora el backend calcula todo
  // La lógica de agrupación y cálculo está centralizada en el backend

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber;

    // Recargar datos con la nueva página desde el backend
    const { fechaDesde, fechaHasta, sku } = this.formHeader.value;
    const inputParams = {
      rut_empresa: this.rutEmpresa,
      sucursal_codigo: this.sucursalCodigo,
      fecha_inicio_busqueda: fechaDesde,
      fecha_termino_busqueda: fechaHasta,
      sku: sku || null,
      producto_codigo: (this.productoSeleccionado && this.productoSeleccionado.codigo) ? this.productoSeleccionado.codigo : 0,
      paginaActual: pageNumber,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage,
    };

    this.loading = true;
    this.analisisDemandaService.obtenerHistoricoQuiebresAgrupado(inputParams, ({ mensajes, respuesta }) => {
      if (mensajes && mensajes.length > 0) {
        const errores = mensajes.filter(m => m.tipo === 'ERROR' || m.tipo === 'WARNING');
        if (errores && errores.length > 0) {
          this.messageRendererService.showErrors(errores);
          this.loading = false;
          return;
        }
      }

      const { registros, totalPaginas, totalRegistros } = respuesta || {
        registros: [],
        totalPaginas: 0,
        totalRegistros: 0
      };

      this.datosReporte = registros || []; // Establecer para que el HTML muestre la tabla
      this.datosReporteUnificado = registros || [];
      this.paginationContext.PagesCount = totalPaginas;
      this.paginationContext.RecordsCount = totalRegistros;

      // Recalcular totales con todos los registros (necesitaríamos obtener todos o calcular en backend)
      this.totalQuiebreCantidad = registros.reduce((sum, item) => sum + Math.abs(item.quiebreCantidad || 0), 0);
      this.totalQuiebreFraccion = registros.reduce((sum, item) => sum + Math.abs(item.quiebreFraccion || 0), 0);

      this.loading = false;
    });
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage);
  }

  exportarExcel() {
    // El método obtenerHistoricoExcel del backend genera el Excel directamente
    // Pasa los mismos filtros que se usan en la búsqueda para mantener consistencia
    const { fechaDesde, fechaHasta, sku } = this.formHeader.value;

    const inputParams = {
      rutEmpresa: this.rutEmpresa,
      obtenerResumen: true,
      fechaDesde: fechaDesde,
      fechaHasta: fechaHasta,
      sucursalCodigo: this.sucursalCodigo,
      sku: sku || null,
      producto_codigo: (this.productoSeleccionado && this.productoSeleccionado.codigo) ? this.productoSeleccionado.codigo : 0,
    };

    this.log('Exportando a Excel:', JSON.stringify(inputParams));

    this.exportandoExcel = true;
    this.analisisDemandaService.obtenerHistoricoExcel(inputParams, ({ mensajes, respuesta }) => {
      this.exportandoExcel = false;
      if (mensajes && mensajes.length > 0) {
        const errores = mensajes.filter(m => m.tipo === 'ERROR' || m.tipo === 'WARNING');
        const infos = mensajes.filter(m => m.tipo === 'INFO');

        if (infos && infos.length > 0) {
          this.messageRendererService.showInfoMessages(infos);
        }
        if (errores && errores.length > 0) {
          this.messageRendererService.showErrors(errores);
          return;
        }
      }

      const ok = respuesta !== null && respuesta !== undefined;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      if (respuesta) {
        this.toastService.success('Excel generado exitosamente');
        this.fileDownloadService.VerifyAndDownload(respuesta);
      }
    });
  }
}


